import noop from 'utils/noop';

export const logFirebasePageView = noop;
